import { useQuery } from "react-query";

import { TaskDuration } from "../../models";
import { getAll } from "../../api/generic-api";
import { RQ } from "../../globals/enums";

export const useTaskDurationsSearch = (searchTerm: string) => {
  return useQuery<TaskDuration[], Error>(
    [RQ.TASK_DURATIONS, searchTerm],
    () => getAll(`task-durations/search?searchTerm=${searchTerm}`),
    {
      enabled: Boolean(searchTerm),
    }
  );
};
